import React from "react";
import data from "../data/author.json";
import {socialLink} from "../global";

const Authorv3 = ({isBg}) => {
  const {authorv3} = data;
  return (
    <section
      id="author"
      className={`section-padding authorv3 ${isBg === "yes" ? "bg-one" : ""}`}
    >
      <div className="container">
        <div className="row">
          <div
            className="col-lg-6"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            <div className="author-image">
              <img
                className="img-fluid"
                src={authorv3.image}
                alt={authorv3.title}
              />
            </div>
          </div>
          <div
            className="col-lg-6"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            <div className="authorv3__content">
              <div className="authorv3__content--badge">
                {authorv3.subtitle}
              </div>
              <h3 className="display-5 mb-0">{authorv3.title}</h3>
              <p className="m-30px-b text-muted fs-5">{authorv3.text}</p>
              <p className="m-30px-b">{authorv3.description}</p>
              <a href="/author" className="smooth button button__primary me-3">
                <span>{authorv3.btnText}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Authorv3;
